import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

const routes: Routes = [
    {
        path: 'public-rejection',
        loadChildren: () => import('./public-rejection/public-rejection.module').then(m => m.PublicRejectionModule)
    },
    {
        path: 'search-my-pickup',
        loadChildren: () => import('./public-pickup-searcher/public-pickup-searcher.module').then(m => m.PublicPickupSearcherModule)
    },
    {
        path: 'public-reservation-assignment',
        loadChildren: () => import('./public-reservation-assignment/public-reservation-assignment.module').then(m => m.PublicReservationAssignmentModule)
    },
    {
        path: 'link',
        loadChildren: () => import('./fallback/fallback.module').then(m => m.FallbackModule)
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
    exports: [RouterModule]
})
export class PublicActionsRoutingModule { }